$('#preview-modal').on('show.bs.modal', function (e) {
  const btn = $(e.relatedTarget);

  const url = btn.data('url');
  const title = btn.data('title');

  imageHtml = `<img src="${url}" />`;

  $(this).find('h4').html(title);
  $(this).find('.preview-img-cnt').html(imageHtml);
});
